// extracted by mini-css-extract-plugin
export default {"axisH":"grafico-proyecciones_axisH__8Touw","axisH_titulo":"grafico-proyecciones_axisH_titulo__kKpz1"};